<!-- Page banner Area -->
<div class="page-banner bg-6">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content service-banner-content">
                    <h2>Our Services</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Services</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<!-- Our Services Area -->
<div class="our-services-area ptb-100">
    <div class="container-fluid">
        <div class="section-title">
            <span class="sub-title-modern">Our Services</span>
            <div class="fs-3 text-black fw-semibold">Safe, Faster and Relaible Lemonmode Services</div>
        </div>

        <div class="row">
            <div class="col-lg-3 col-md-6 d-flex">
                <div class="service-card-two d-flex flex-column w-100 h-100">
                    <img src="assets/img/land transport.jpg" alt="image">
                    <div class="service-caption d-flex flex-column flex-grow-1">
                        <h3>Road Freight</h3>
                        <p>Transport or Movement of people, animals or goods from one location to another location on
                            land.</p>
                        <a routerLink="/road-fright-service-details" class="default-btn-two mt-auto">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 d-flex">
                <div class="service-card-two d-flex flex-column w-100 h-100">
                    <img src="assets/img/ship-transport-service.jpg" alt="image">
                    <div class="service-caption d-flex flex-column flex-grow-1">
                        <h3>Ocean Freight</h3>
                        <p>BShippabo provides real-time supply chain visibility and expertise to growing businesses.</p>
                        <a routerLink="/ocean-fright-service-details" class="default-btn-two mt-auto">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 d-flex">
                <div class="service-card-two d-flex flex-column w-100 h-100">
                    <img src="assets/img/fight service .jpg" alt="image">
                    <div class="service-caption d-flex flex-column flex-grow-1">
                        <h3>Air Freight</h3>
                        <p>Air freight, on the other hand, means the amount to be paid for the transportation of goods
                            by air.</p>
                        <a routerLink="/air-fright-services-details" class="default-btn-two mt-auto">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 d-flex">
                <div class="service-card-two d-flex flex-column w-100 h-100">
                    <img src="assets/img/cargo storage.png" alt="image">
                    <div class="service-caption d-flex flex-column flex-grow-1">
                        <h3>Cargo Storage</h3>
                        <p>This section describes transportation and delivery in the logistics functions of storage and
                            cargo handling.</p>
                        <a routerLink="/cargo-storage-service-details" class="default-btn-two mt-auto">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 d-flex">
                <div class="service-card-two d-flex flex-column w-100 h-100">
                    <img src="assets/img/warehouse (1).jpg" alt="image">
                    <div class="service-caption d-flex flex-column flex-grow-1">
                        <h3>Warehousing</h3>
                        <p>Warehousing is the act of storing goods that will be sold or distributed later.</p>
                        <a routerLink="/warehousing-service-details" class="default-btn-two mt-auto">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 d-flex">
                <div class="service-card-two d-flex flex-column w-100 h-100">
                    <img src="assets/img/e-commere-sol.webp" alt="image">
                    <div class="service-caption d-flex flex-column flex-grow-1">
                        <h3>E-commerce solutions</h3>
                        <p>E-commerce solutions are the products and services that help a company conduct business.</p>
                        <a routerLink="/ecommerce-service-details" class="default-btn-two mt-auto">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 d-flex">
                <div class="service-card-two d-flex flex-column w-100 h-100">
                    <img src="assets/img/express-services.webp" alt="image">
                    <div class="service-caption d-flex flex-column flex-grow-1">
                        <h3>Express Services</h3>
                        <p>Through this service, expatriate employee can check the work permit application status.</p>
                        <a routerLink="/express-service-details" class="default-btn-two mt-auto">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 d-flex">
                <div class="service-card-two d-flex flex-column w-100 h-100">
                    <img src="assets/img/domestic truking.png" alt="image">
                    <div class="service-caption d-flex flex-column flex-grow-1">
                        <h3>Domestic Trucking</h3>
                        <p>Domestic Transportation and Road Transportation Services using own fleet vehicles.</p>
                        <a routerLink="/domesticTrucking-service-details" class="default-btn-two mt-auto">Read More</a>
                    </div>
                </div>
            </div>

            <!-- <div class="col-lg-12 col-md-12">
                <ul class="pagination">
                    <li class="page-item"><a class="page-link" routerLink="/services"><span
                                aria-hidden="true">&laquo;</span></a></li>
                    <li class="page-item active"><a class="page-link" routerLink="/services">1</a></li>
                    <li class="page-item"><a class="page-link" routerLink="/services">2</a></li>
                    <li class="page-item"><a class="page-link" routerLink="/services">3</a></li>
                    <li class="page-item"><a class="page-link" routerLink="/services"><span
                                aria-hidden="true">&raquo;</span></a></li>
                </ul>
            </div> -->
        </div>
    </div>
</div>
<!-- Our End Services Area -->

<!-- Best Logistic Area -->
<div class="best-logistic-area pb-70 container-fluid">
    <div class="row align-items-center g-4">
        <div class="col-lg-5 col-md-12">
            <div class="logistic-text px-lg-4">
                <div class="section-title text-center mb-4">
                    <span class="sub-title-modern">Best Services</span>
                   <div class="fs-3 text-black fw-semibold">Best <span>Lemonmode Service</span> Solution Near you</div>
                </div>

                <div class="row g-3 row-cols-3">
                    <div class="col">
                        <div class="service-feature-card h-100 text-center p-3">
                            <div class="service-feature-icon mx-auto mb-3 feature-float feature-delay-1">
                                <img src="assets/img/fast.png" alt="Fast">
                            </div>
                            <div class="fw-semibold text-dark small">Fast</div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="service-feature-card h-100 text-center p-3">
                            <div class="service-feature-icon mx-auto mb-3 feature-float feature-delay-2">
                                <img src="assets/img/reliable.png" alt="Reliable">
                            </div>
                            <div class="fw-semibold text-dark small">Reliable</div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="service-feature-card h-100 text-center p-3">
                            <div class="service-feature-icon mx-auto mb-3 feature-float feature-delay-3">
                                <img src="assets/img/Efficient.png" alt="Efficient">
                            </div>
                            <div class="fw-semibold text-dark small">Efficient</div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="service-feature-card h-100 text-center p-3">
                            <div class="service-feature-icon mx-auto mb-3 feature-float feature-delay-4">
                                <img src="assets/img/economical.png" alt="Economical">
                            </div>
                            <div class="fw-semibold text-dark small">Economical</div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="service-feature-card h-100 text-center p-3">
                            <div class="service-feature-icon mx-auto mb-3 feature-float feature-delay-5">
                                <img src="assets/img/secure.png" alt="Secure">
                            </div>
                            <div class="fw-semibold text-dark small">Secure</div>
                        </div>
                    </div>
                </div>

                <div class="mt-4 text-center">
                    <a routerLink="/about" class="default-btn-one">Learn More</a>
                </div>
            </div>
        </div>

        <div class="col-lg-7 col-md-12">
            <div class="logistic-image rounded-4 overflow-hidden shadow-lg h-100">
                <img src="assets/img/bg-image-1.png" alt="image">
            </div>
        </div>
    </div>
</div>
<!-- End Best Logistic Area -->

<!-- Newsletter Area -->
<div class="newsletter-area">
    <div class="container">
        <div class="newsletter-content">
            <div class="row align-items-center">
                <!-- <div class="col-lg-5 col-md-12">
                    <div class="newsletter-title">
                        <h3>Subscribe to our newsletter:</h3>
                        <p>Focused on the transport and logistic industry</p>
                    </div>
                </div>

                <div class="col-lg-7 col-md-12">
                    <form class="newsletter-form">
                        <input type="email" class="form-control" placeholder="Enter your email" name="EMAIL" required=""
                            autocomplete="off">
                        <button type="submit" class="btn btn-primary">Subscribe</button>
                    </form>
                </div> -->
            </div>
        </div>
    </div>
</div>
<!-- End Newsletter Area -->